import { userData } from "util/userData";
import { HttpRequest } from "util/http";

interface IReview {
  id: number;
  platform: string;
  customer: string;
  locationId: string;
  name: string;
  reviewId: string;
  reviewerName: string;
  reviewerIsAnonymous: boolean;
  reviewrProfilePhotoUrl: string;
  starRating: number;
  comment: string;
  createTime: Date;
  updateTime: Date;
  replyComment?: string;
  replyTime?: Date;
  commentCodes?: string[];
  viewed?: string;
  reviewUrl?: string;
  hasComments?: boolean;
  address?: string;
  addressLineTwo?: string;
  city?: string;
  state?: string;
  zipcode?: string;
  locationName?: string;
}

interface ICommentCode {
  id: number;
  reviewsId: number;
  commentCode: number;
  isDeleted: boolean;
  createDate: Date;
  createBy: string;
  updateDate: Date;
  updateBy: string;
}

export const getReview = (id: number) => {
  const method = "POST";
  const data = { id };

  return HttpRequest.fetch<IReview>("scripts/social_media/getReview", {
    data,
    method,
  }).then((review) => {
    return review;
  });
};

export const getReviews = (
  filters = userData.getFilters(),
  hideComments: boolean
) => {
  const method = "POST";
  const data: any = { ...filters, hideComments };

  return HttpRequest.fetch<IReview[]>("/scripts/social_media/getReviews", {
    data,
    method,
  }).then((res) => {
    return res;
  });
};

export const updateReview = (review: IReview) => {
  const method = "POST";
  const [
    code1Edit = null,
    code2Edit = null,
    code3Edit = null,
    code4Edit = null,
    code5Edit = null,
    code6Edit = null,
  ] = review.commentCodes;
  const data = {
    review,
    code1Edit,
    code2Edit,
    code3Edit,
    code4Edit,
    code5Edit,
    code6Edit,
  };

  return HttpRequest.fetch<IReview[]>(
    "/scripts/social_media/updateReview",
    { data, method }
  ).then((res) => {
    return res;
  });
};

export { IReview, ICommentCode };
